import { Divider, Grid, Stack } from '@mui/material'
import { HearingSummaryProps } from 'components/HearingSummary'
import {
  formatInfraction,
  validateNarrativeInfractionList,
} from 'components/HearingSummary/utils/validate-field.util'
import Label from 'components/Label'
import React from 'react'
import { HearingNarrativesType } from 'types/hearing-narratives.type'

export const InfractionGroup: React.FC<HearingSummaryProps<HearingNarrativesType>> = ({ data }) => {
  const infractionsField = validateNarrativeInfractionList(data)

  return (
    <>
      <Label text='ATOS INFRACIONAIS' v='h6' bold />
      <Divider />
      <Grid container item spacing={1} sx={{ mt: 2, ml: 0.1 }}>
        <Stack direction='column' spacing={1}>
          {infractionsField.map((item, i) => (
            <p key={i} style={{ fontSize: 14, margin: 0 }}>
              {formatInfraction(item, i)}
            </p>
          ))}
        </Stack>
      </Grid>
    </>
  )
}
